//@ts-nocheck
import { Registry } from '@react-registry'
import isUrl from 'is-url'

import { wrapLink } from './utils'
import { Editor, Transforms, Range, Path, Element, Node } from 'slate'

export const withHyperlinks = (editor) => {
  const { insertData, insertText, isInline, insertBreak, normalizeNode } = editor

  editor.isInline = (element) => {
    return element.type === 'a' ? true : isInline(element)
  }

  editor.insertText = (text) => {
    if (text && isUrl(text)) {
      wrapLink(editor, text)
    } else {
      if (/\s/g.test(text)) {
        const [anchorNode, anchorPath] = Editor.parent(editor, editor.selection)
        if (
          // Move cursor position to the next text node
          Range.isCollapsed(editor.selection) &&
          Editor.isEnd(editor, editor.selection.focus, anchorPath) &&
          (anchorNode.type === 'a' || anchorNode?.attrs?.['display-type'] === 'link')
        ) {
          Transforms.move(editor, { distance: 1, unit: 'offset' })
        }
      }
      insertText(text)
    }
  }

  editor.normalizeNode = (entry) => {
    if (Element.isElement(entry[0])) {
      const [element, path] = entry;
      if ((element['type'] === 'a' || element['attrs']?.['display-type'] === 'link') && Node.string(element) === '') {
        //check if anchor node has no child text nodes
        if (element.children.length < 1) {
          Transforms.insertNodes(editor, { type: "p", children: [{ text: "" }] }, { at: path })
        }
        else {
          Transforms.unwrapNodes(editor, { at: path });
        }
      }
    }
    normalizeNode(entry);
  }

  editor.insertBreak = () => {
    const [selectedElement, path] = Editor.parent(editor, editor.selection);

    if (selectedElement.type === 'a' || selectedElement?.attrs?.['display-type'] === 'link') {
      const endPoint = Range.end(editor.selection);
      const [selectedLeaf] = Editor.node(editor, endPoint);
      //@ts-ignore
      if (selectedLeaf.text.length === endPoint.offset) {
        if (Range.isExpanded(editor.selection)) {
          Transforms.delete(editor);
        }

        // Transforms.select(editor, Path.next(path));
      }
    }
    insertBreak();
  };

  editor.insertData = (data) => {
    const text = data.getData('text/plain')

    if (text && isUrl(text)) {
      wrapLink(editor, text)
    } else {
      insertData(data)
    }
  }

  return editor
}

Registry.register(withHyperlinks, { id: 'withHyperlinks', registry: 'v2.plugin' })
